import { useCallback, useEffect, useId } from 'react';
import type { ComponentType } from 'react';
import { useDialogContext } from '../components/dialog-provider';
import type { DialogBaseProps } from '../components/dialog-provider';

function useDialog<TProps extends DialogBaseProps>(component: ComponentType<TProps>) {
  const id = useId();
  const { register, unregister, open, close } = useDialogContext();

  useEffect(() => {
    register(id, component as ComponentType<DialogBaseProps>);
    return () => unregister(id);
  }, [id, register, unregister, component]);

  return {
    open: useCallback(
      (props: Omit<TProps, 'onClose'>) => open(id, props as Record<string, unknown>),
      [id, open]
    ),
    close: useCallback(() => close(id), [id, close]),
  };
}

export { useDialog };
